const {createPipeline} = require("cleopatra");
const {reportAndThrow} = require("app/util/errors");

const open = createPipeline().report(reportAndThrow);
const close = createPipeline().report(reportAndThrow);
const toggle = createPipeline().report(reportAndThrow);

module.exports = {
	open,
	close,
	toggle
};